// timestamp of build
export const timestamp = '29.2.2024, 13:06:52 UTC';
// version
export const version = '1.0.0'